import React from 'react'
import { useLatestPosts, LatestPostsProps } from './useLatestPosts'
import styles from './LatestPosts.module.scss'
import { Link } from 'react-router-dom'
import TitleSection from 'components/TitleSection/TitleSection'
import PostCard from 'components/PostCard/PostCard'
import AnimatedContainer from 'components/AnimatedContainer/AnimatedContainer'

const LatestPosts: React.FC<LatestPostsProps> = (props: LatestPostsProps) => {
  const { latestPostsData, isAr, animations, animationsReversed, t } =
    useLatestPosts(props)

  return (
    <section id='latest-posts' className={styles['latest-posts']}>
      <TitleSection title={t('LatestPosts')} />
      <div className='container'>
        <div className='row mb-4 mb-lg-5'>
          {latestPostsData &&
            latestPostsData.length &&
            latestPostsData.map((post, index) => {
              const description = isAr ? post.descriptionAr : post.descriptionEn
              let shortDescription = ''

              if (
                description &&
                description.length > 0 &&
                description[0].children &&
                description[0].children.length > 0
              ) {
                const firstText = description[0].children[0].text
                shortDescription = `${firstText.substring(0, 100)}...`
              } else shortDescription = t('noDetails')

              return (
                <div
                  key={`post-${post.id}-${index}`}
                  className='col-lg-4 mb-3 mb-lg-0'
                >
                  <AnimatedContainer
                    animation={
                      isAr
                        ? animations[index % animations.length]
                        : animationsReversed[index % animationsReversed.length]
                    }
                    extraCssClasses='h-100'
                  >
                    <PostCard
                      image={post.image}
                      description={shortDescription}
                      title={isAr ? post.titleAr : post.titleEn}
                      author={isAr ? post.author.nameAr : post.author.nameEn}
                      authorImage={post.author.photo}
                      category={
                        isAr ? post.category.nameAr : post.category.nameEn
                      }
                      url={`/PostDetails/${post.slugAr}`}
                      date={post.publishedAt.split('T')[0]}
                      isFeatured={!!post.featured}
                      isAr={isAr}
                    />
                  </AnimatedContainer>
                </div>
              )
            })}
        </div>
        <div className='row'>
          <div className='col-12 text-center'>
            <Link to='/Posts' className='btn btn-secondary px-5 py-2'>
              {t('AllPosts')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LatestPosts
